import styled from '@emotion/styled';

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font: inherit;
  display: flex;
  color: black;
  white-space: nowrap;
`;
